var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cases-header',{attrs:{"actIndex":_vm.actIndex,"imgList":_vm.imgList,"topStyle":_vm.topStyle,"titleObj":_vm.titleObj,"logo":_vm.logo}}),_vm._v(" "),_c('cases-center',{attrs:{"cases":_vm.caseInfo,"type":_vm.caseType}}),_vm._v(" "),_c('cases-footer',{attrs:{"bottom":_vm.bottom,"bottomInfo":_vm.contactInfo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a9e4b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/Cases.vue
// module id = null
// module chunks = 